import React, { useRef } from 'react';

import { useRouter } from 'next/router';
import * as Survey from 'survey-react';

import useOnClickOutside from '@components/common/hooks/useOnClickOutside';
import Modal from '@components/common/Modals/Modal/Modal';
import SurveyService from '@services/domain/Lpc/SurveyService';
import ObjectService from '@services/utils/ObjectService';

import css from './SurveyModal.module.scss';

type IbanModalProps = {
    isVisible: boolean;
    onHide: () => void;
};

const SurveyModal = ({ isVisible, onHide }: IbanModalProps) => {
    Survey.StylesManager.applyTheme('defaultV2');
    const router = useRouter();
    const avatarRef = useRef();
    useOnClickOutside(avatarRef, () => onHide());
    const json = {
        completedHtml:
            '<h3>Merci !</h3><br><img src="https://i.pinimg.com/originals/3e/a6/a2/3ea6a272e8368ad0219a8cb148ff7caa.gif" alt="bravo"/>',
        pageNextText: 'Suivant',
        nextPageMouseDown: 'true',
        locale: 'fr',
        pages: [
            {
                name: 'page1',
                elements: [
                    {
                        type: 'html',
                        name: 'first_question_title',
                        html:
                            '<h5>Votre avis nous intéresse !  <img src="/front-static/icons/display/survey.png" alt="survey" width="27px" style="\n' +
                            '    top: 5px;\n' +
                            '    position: relative;\n' +
                            '"></h5>',
                    },
                    {
                        type: 'rating',
                        name: 'nps_score',
                        title: 'Seriez vous prêt (e) à recommander Le pot commun à un ami ?',
                        isRequired: true,
                        rateMin: 0,
                        rateMax: 10,
                        minRateDescription: 'Peu probable',
                        displayMode: 'buttons',
                        maxRateDescription: 'Très probable',
                    },
                ],
            },
            {
                name: 'page2',
                elements: [
                    {
                        type: 'html',
                        name: 'second_question_title',
                        html: '<h5>En quelques mots</h5>',
                    },
                    {
                        type: 'comment',
                        name: 'comment',
                        title: 'Pourriez-vous nous expliquer brièvement votre choix ?',
                        placeholder: 'Indiquez votre réponse ici...',
                    },
                ],
            },
        ],
        showQuestionNumbers: 'off',
    };

    const survey = new Survey.Model(json);
    survey.onComplete.add(function (sender) {
        const body = {
            score: sender.data.nps_score,
            comment: sender.data.comment,
            uniqPO: router.query.uniqPO,
            orderId: router.query.orderId,
        };
        return SurveyService.submitSurvey(body);
    });
    survey.onValueChanged.add(function (sender) {
        setTimeout(() => {
            const next = document.getElementsByClassName('sd-navigation__next-btn');
            const rates = document.getElementsByClassName('sd-rating__item');
            if (ObjectService.hasContent(rates)) {
                next[0].classList.remove('nps_colored');
                for (let i = 0; i <= 10; i++) {
                    rates[i].classList.remove('nps_colored');
                    // @ts-ignore
                    if (i <= sender.valuesHash.nps_score) {
                        next[0].classList.add('nps_colored');
                        rates[i].classList.add('nps_colored');
                    }
                }
            }
        });
    });

    return (
        <>
            <Modal visible={isVisible} onHide={onHide} customClass={css.custom}>
                <div className={css.surveyContainer} ref={avatarRef}>
                    <Survey.Survey model={survey} className={css.survey} />
                </div>
            </Modal>
        </>
    );
};

export default SurveyModal;
